import { FC } from 'react';
import { faArrowDownRight } from '@fortawesome/pro-regular-svg-icons/faArrowDownRight';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { Badge, BadgeProps, Icon } from '@kontentino/ui';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import NumberUtil from 'utils/number';
import type { ChangeDirection } from 'api/new-analytics/types';

interface ComparisonBadgeProps {
  percentage?: number;
  direction?: ChangeDirection;
  showIcon?: boolean;
}

const ComparisonBadge: FC<ComparisonBadgeProps> = ({
  percentage,
  direction,
  showIcon = true,
}) => {
  if (percentage === undefined) {
    if (direction === 'up') {
      return (
        <Badge variant="success">
          <Icon icon={faArrowUpRight} size={12} />
        </Badge>
      );
    }
    if (direction === 'down') {
      return (
        <Badge variant="destructive">
          <Icon icon={faArrowDownRight} size={12} />
        </Badge>
      );
    }
    return null;
  }

  const displayedPercentage = Number(percentage.toFixed(2)) || 0;
  const sign = Math.sign(displayedPercentage) as 0 | 1 | -1;

  let variant: BadgeProps['variant'];
  let icon: IconDefinition | null;
  switch (sign) {
    case 1:
      variant = 'success';
      icon = faArrowUpRight;
      break;
    case -1:
      variant = 'destructive';
      icon = faArrowDownRight;
      break;
    default:
      variant = 'gray';
      icon = null;
      break;
  }

  const label = `${sign === 1 ? '+' : ''}${NumberUtil.compact(
    displayedPercentage,
  )}%`;

  return (
    <Badge variant={variant}>
      {showIcon && icon && <Icon icon={icon} size={12} />}
      {label}
    </Badge>
  );
};

export default ComparisonBadge;
